module.exports = __webpack_public_path__ + "media/images/product_large_images/printer2(600)-132ede03ac861ebbd3b5de9b77c016e6.png";